module.exports = __webpack_public_path__ + "static/media/expired.0959a069.gif";